module.exports = __webpack_public_path__ + "static/media/search.90e9d461.svg";